module.exports = __webpack_public_path__ + "fonts/SofiaProUltraLight-Italic.1fb2bb25.woff";